export default () => (
    <svg
        version="1.2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 900 736"
        width="900"
        height="736"
    >
        <defs>
            <linearGradient id="P" gradientUnits="userSpaceOnUse" />
            <radialGradient
                id="g1"
                cx="0"
                cy="0"
                r="1"
                href="#P"
                gradientTransform="matrix(510.15,0,0,510.15,454.16,367.79)"
            >
                <stop stopColor="#b2d4ff" stopOpacity="1" />
                <stop offset=".05" stopColor="#b6d6ff" stopOpacity=".95" />
                <stop offset=".15" stopColor="#c0dbff" stopOpacity=".83" />
                <stop offset=".28" stopColor="#d2e4ff" stopOpacity=".63" />
                <stop offset=".36" stopColor="#deebff" stopOpacity=".5" />
                <stop offset=".45" stopColor="#e0ecff" stopOpacity=".47" />
                <stop offset=".59" stopColor="#e6efff" stopOpacity=".38" />
                <stop offset=".77" stopColor="#eff5ff" stopOpacity=".23" />
                <stop offset=".98" stopColor="#fdfdff" stopOpacity=".03" />
                <stop offset="1" stopColor="#fff" stopOpacity="0" />
            </radialGradient>
            <linearGradient
                id="g2"
                x2="1"
                href="#P"
                gradientTransform="matrix(182.36,455.53,-454.652,182.008,554.01,156.54)"
            >
                <stop offset=".07" stopColor="#fff" />
                <stop offset=".39" stopColor="#fbfcff" />
                <stop offset=".71" stopColor="#eff5ff" />
                <stop offset="1" stopColor="#deebff" />
            </linearGradient>
            <linearGradient
                id="g3"
                x2="1"
                href="#P"
                gradientTransform="matrix(-283.61,-355.81,353.148,-281.489,815.59,543.53)"
            >
                <stop stopColor="#deebff" stopOpacity="1" />
                <stop offset=".1" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".22" stopColor="#e0ecff" stopOpacity=".92" />
                <stop offset=".34" stopColor="#e3eeff" stopOpacity=".83" />
                <stop offset=".47" stopColor="#e7f1ff" stopOpacity=".7" />
                <stop offset=".61" stopColor="#edf4ff" stopOpacity=".53" />
                <stop offset=".75" stopColor="#f4f8ff" stopOpacity=".32" />
                <stop offset=".89" stopColor="#fcfdff" stopOpacity=".08" />
                <stop offset=".94" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="g4"
                x2="1"
                href="#P"
                gradientTransform="matrix(-283.61,-355.82,408.589,-325.67,863.39,505.43)"
            >
                <stop stopColor="#deebff" stopOpacity="1" />
                <stop offset=".1" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".22" stopColor="#e0ecff" stopOpacity=".92" />
                <stop offset=".34" stopColor="#e3eeff" stopOpacity=".83" />
                <stop offset=".47" stopColor="#e7f1ff" stopOpacity=".7" />
                <stop offset=".61" stopColor="#edf4ff" stopOpacity=".53" />
                <stop offset=".75" stopColor="#f4f8ff" stopOpacity=".32" />
                <stop offset=".89" stopColor="#fcfdff" stopOpacity=".08" />
                <stop offset=".94" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="g5"
                x2="1"
                href="#P"
                gradientTransform="matrix(-283.61,-355.82,408.589,-325.67,784.15,568.6)"
            >
                <stop stopColor="#deebff" stopOpacity="1" />
                <stop offset=".1" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".22" stopColor="#e0ecff" stopOpacity=".92" />
                <stop offset=".34" stopColor="#e3eeff" stopOpacity=".83" />
                <stop offset=".47" stopColor="#e7f1ff" stopOpacity=".7" />
                <stop offset=".61" stopColor="#edf4ff" stopOpacity=".53" />
                <stop offset=".75" stopColor="#f4f8ff" stopOpacity=".32" />
                <stop offset=".89" stopColor="#fcfdff" stopOpacity=".08" />
                <stop offset=".94" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="g6"
                x2="1"
                href="#P"
                gradientTransform="matrix(-283.61,-355.82,408.589,-325.67,771.02,579.06)"
            >
                <stop stopColor="#deebff" stopOpacity="1" />
                <stop offset=".1" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".22" stopColor="#e0ecff" stopOpacity=".92" />
                <stop offset=".34" stopColor="#e3eeff" stopOpacity=".83" />
                <stop offset=".47" stopColor="#e7f1ff" stopOpacity=".7" />
                <stop offset=".61" stopColor="#edf4ff" stopOpacity=".53" />
                <stop offset=".75" stopColor="#f4f8ff" stopOpacity=".32" />
                <stop offset=".89" stopColor="#fcfdff" stopOpacity=".08" />
                <stop offset=".94" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="g7"
                x2="1"
                href="#P"
                gradientTransform="matrix(-283.61,-355.82,408.589,-325.67,757.9,589.52)"
            >
                <stop stopColor="#deebff" stopOpacity="1" />
                <stop offset=".1" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".22" stopColor="#e0ecff" stopOpacity=".92" />
                <stop offset=".34" stopColor="#e3eeff" stopOpacity=".83" />
                <stop offset=".47" stopColor="#e7f1ff" stopOpacity=".7" />
                <stop offset=".61" stopColor="#edf4ff" stopOpacity=".53" />
                <stop offset=".75" stopColor="#f4f8ff" stopOpacity=".32" />
                <stop offset=".89" stopColor="#fcfdff" stopOpacity=".08" />
                <stop offset=".94" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="g8"
                x2="1"
                href="#P"
                gradientTransform="matrix(-283.61,-355.82,408.589,-325.67,744.77,599.98)"
            >
                <stop stopColor="#deebff" stopOpacity="1" />
                <stop offset=".1" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".22" stopColor="#e0ecff" stopOpacity=".92" />
                <stop offset=".34" stopColor="#e3eeff" stopOpacity=".83" />
                <stop offset=".47" stopColor="#e7f1ff" stopOpacity=".7" />
                <stop offset=".61" stopColor="#edf4ff" stopOpacity=".53" />
                <stop offset=".75" stopColor="#f4f8ff" stopOpacity=".32" />
                <stop offset=".89" stopColor="#fcfdff" stopOpacity=".08" />
                <stop offset=".94" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="g9"
                x2="1"
                href="#P"
                gradientTransform="matrix(-283.61,-355.82,408.589,-325.67,850.36,515.82)"
            >
                <stop stopColor="#deebff" stopOpacity="1" />
                <stop offset=".1" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".22" stopColor="#e0ecff" stopOpacity=".92" />
                <stop offset=".34" stopColor="#e3eeff" stopOpacity=".83" />
                <stop offset=".47" stopColor="#e7f1ff" stopOpacity=".7" />
                <stop offset=".61" stopColor="#edf4ff" stopOpacity=".53" />
                <stop offset=".75" stopColor="#f4f8ff" stopOpacity=".32" />
                <stop offset=".89" stopColor="#fcfdff" stopOpacity=".08" />
                <stop offset=".94" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="g10"
                x2="1"
                href="#P"
                gradientTransform="matrix(-283.61,-355.82,408.589,-325.67,797.28,558.13)"
            >
                <stop stopColor="#deebff" stopOpacity="1" />
                <stop offset=".1" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".22" stopColor="#e0ecff" stopOpacity=".92" />
                <stop offset=".34" stopColor="#e3eeff" stopOpacity=".83" />
                <stop offset=".47" stopColor="#e7f1ff" stopOpacity=".7" />
                <stop offset=".61" stopColor="#edf4ff" stopOpacity=".53" />
                <stop offset=".75" stopColor="#f4f8ff" stopOpacity=".32" />
                <stop offset=".89" stopColor="#fcfdff" stopOpacity=".08" />
                <stop offset=".94" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="g11"
                x2="1"
                href="#P"
                gradientTransform="matrix(-283.61,-355.82,408.589,-325.67,823.14,537.51)"
            >
                <stop stopColor="#deebff" stopOpacity="1" />
                <stop offset=".1" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".22" stopColor="#e0ecff" stopOpacity=".92" />
                <stop offset=".34" stopColor="#e3eeff" stopOpacity=".83" />
                <stop offset=".47" stopColor="#e7f1ff" stopOpacity=".7" />
                <stop offset=".61" stopColor="#edf4ff" stopOpacity=".53" />
                <stop offset=".75" stopColor="#f4f8ff" stopOpacity=".32" />
                <stop offset=".89" stopColor="#fcfdff" stopOpacity=".08" />
                <stop offset=".94" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="g12"
                x2="1"
                href="#P"
                gradientTransform="matrix(-283.61,-355.82,408.589,-325.67,810.59,547.52)"
            >
                <stop stopColor="#deebff" stopOpacity="1" />
                <stop offset=".1" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".22" stopColor="#e0ecff" stopOpacity=".92" />
                <stop offset=".34" stopColor="#e3eeff" stopOpacity=".83" />
                <stop offset=".47" stopColor="#e7f1ff" stopOpacity=".7" />
                <stop offset=".61" stopColor="#edf4ff" stopOpacity=".53" />
                <stop offset=".75" stopColor="#f4f8ff" stopOpacity=".32" />
                <stop offset=".89" stopColor="#fcfdff" stopOpacity=".08" />
                <stop offset=".94" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="g13"
                x2="1"
                href="#P"
                gradientTransform="matrix(-283.61,-355.82,440.78,-351.329,827.78,533.82)"
            >
                <stop stopColor="#deebff" stopOpacity="1" />
                <stop offset=".1" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".22" stopColor="#e0ecff" stopOpacity=".92" />
                <stop offset=".34" stopColor="#e3eeff" stopOpacity=".83" />
                <stop offset=".47" stopColor="#e7f1ff" stopOpacity=".7" />
                <stop offset=".61" stopColor="#edf4ff" stopOpacity=".53" />
                <stop offset=".75" stopColor="#f4f8ff" stopOpacity=".32" />
                <stop offset=".89" stopColor="#fcfdff" stopOpacity=".08" />
                <stop offset=".94" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="g14"
                x2="1"
                href="#P"
                gradientTransform="matrix(-283.61,-355.82,440.78,-351.329,814.74,544.21)"
            >
                <stop stopColor="#deebff" stopOpacity="1" />
                <stop offset=".1" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".22" stopColor="#e0ecff" stopOpacity=".92" />
                <stop offset=".34" stopColor="#e3eeff" stopOpacity=".83" />
                <stop offset=".47" stopColor="#e7f1ff" stopOpacity=".7" />
                <stop offset=".61" stopColor="#edf4ff" stopOpacity=".53" />
                <stop offset=".75" stopColor="#f4f8ff" stopOpacity=".32" />
                <stop offset=".89" stopColor="#fcfdff" stopOpacity=".08" />
                <stop offset=".94" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="g15"
                x2="1"
                href="#P"
                gradientTransform="matrix(-283.61,-355.82,440.78,-351.329,801.7,554.6)"
            >
                <stop stopColor="#deebff" stopOpacity="1" />
                <stop offset=".1" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".22" stopColor="#e0ecff" stopOpacity=".92" />
                <stop offset=".34" stopColor="#e3eeff" stopOpacity=".83" />
                <stop offset=".47" stopColor="#e7f1ff" stopOpacity=".7" />
                <stop offset=".61" stopColor="#edf4ff" stopOpacity=".53" />
                <stop offset=".75" stopColor="#f4f8ff" stopOpacity=".32" />
                <stop offset=".89" stopColor="#fcfdff" stopOpacity=".08" />
                <stop offset=".94" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="g16"
                x2="1"
                href="#P"
                gradientTransform="matrix(-283.61,-355.82,440.78,-351.329,788.67,564.99)"
            >
                <stop stopColor="#deebff" stopOpacity="1" />
                <stop offset=".1" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".22" stopColor="#e0ecff" stopOpacity=".92" />
                <stop offset=".34" stopColor="#e3eeff" stopOpacity=".83" />
                <stop offset=".47" stopColor="#e7f1ff" stopOpacity=".7" />

                <stop offset=".61" stopColor="#edf4ff" stopOpacity=".53" />

                <stop offset=".75" stopColor="#f4f8ff" stopOpacity=".32" />

                <stop offset=".89" stopColor="#fcfdff" stopOpacity=".08" />

                <stop offset=".94" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="g17"
                x2="1"
                href="#P"
                gradientTransform="matrix(-283.61,-355.82,440.78,-351.329,775.63,575.38)"
            >
                <stop stopColor="#deebff" stopOpacity="1" />
                <stop offset=".1" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".22" stopColor="#e0ecff" stopOpacity=".92" />
                <stop offset=".34" stopColor="#e3eeff" stopOpacity=".83" />
                <stop offset=".47" stopColor="#e7f1ff" stopOpacity=".7" />
                <stop offset=".61" stopColor="#edf4ff" stopOpacity=".53" />
                <stop offset=".75" stopColor="#f4f8ff" stopOpacity=".32" />
                <stop offset=".89" stopColor="#fcfdff" stopOpacity=".08" />
                <stop offset=".94" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="g18"
                x2="1"
                href="#P"
                gradientTransform="matrix(-283.61,-355.82,440.78,-351.329,762.6,585.77)"
            >
                <stop stopColor="#deebff" stopOpacity="1" />
                <stop offset=".1" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".22" stopColor="#e0ecff" stopOpacity=".92" />
                <stop offset=".34" stopColor="#e3eeff" stopOpacity=".83" />
                <stop offset=".47" stopColor="#e7f1ff" stopOpacity=".7" />
                <stop offset=".61" stopColor="#edf4ff" stopOpacity=".53" />
                <stop offset=".75" stopColor="#f4f8ff" stopOpacity=".32" />
                <stop offset=".89" stopColor="#fcfdff" stopOpacity=".08" />
                <stop offset=".94" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="g19"
                x2="1"
                href="#P"
                gradientTransform="matrix(-283.61,-355.81,440.756,-351.319,749.56,596.16)"
            >
                <stop stopColor="#deebff" stopOpacity="1" />
                <stop offset=".1" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".22" stopColor="#e0ecff" stopOpacity=".92" />
                <stop offset=".34" stopColor="#e3eeff" stopOpacity=".83" />
                <stop offset=".47" stopColor="#e7f1ff" stopOpacity=".7" />
                <stop offset=".61" stopColor="#edf4ff" stopOpacity=".53" />
                <stop offset=".75" stopColor="#f4f8ff" stopOpacity=".32" />
                <stop offset=".89" stopColor="#fcfdff" stopOpacity=".08" />
                <stop offset=".94" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="g20"
                x2="1"
                href="#P"
                gradientTransform="matrix(-283.61,-355.81,440.756,-351.319,736.52,606.55)"
            >
                <stop stopColor="#deebff" stopOpacity="1" />
                <stop offset=".1" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".22" stopColor="#e0ecff" stopOpacity=".92" />
                <stop offset=".34" stopColor="#e3eeff" stopOpacity=".83" />
                <stop offset=".47" stopColor="#e7f1ff" stopOpacity=".7" />
                <stop offset=".61" stopColor="#edf4ff" stopOpacity=".53" />
                <stop offset=".75" stopColor="#f4f8ff" stopOpacity=".32" />
                <stop offset=".89" stopColor="#fcfdff" stopOpacity=".08" />
                <stop offset=".94" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="g21"
                x2="1"
                href="#P"
                gradientTransform="matrix(-283.61,-355.82,440.78,-351.329,723.49,616.95)"
            >
                <stop stopColor="#deebff" stopOpacity="1" />
                <stop offset=".1" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".22" stopColor="#e0ecff" stopOpacity=".92" />
                <stop offset=".34" stopColor="#e3eeff" stopOpacity=".83" />
                <stop offset=".47" stopColor="#e7f1ff" stopOpacity=".7" />
                <stop offset=".61" stopColor="#edf4ff" stopOpacity=".53" />
                <stop offset=".75" stopColor="#f4f8ff" stopOpacity=".32" />
                <stop offset=".89" stopColor="#fcfdff" stopOpacity=".08" />
                <stop offset=".94" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="g22"
                x2="1"
                href="#P"
                gradientTransform="matrix(-283.61,-355.82,440.78,-351.329,710.45,627.34)"
            >
                <stop stopColor="#deebff" stopOpacity="1" />
                <stop offset=".1" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".22" stopColor="#e0ecff" stopOpacity=".92" />
                <stop offset=".34" stopColor="#e3eeff" stopOpacity=".83" />
                <stop offset=".47" stopColor="#e7f1ff" stopOpacity=".7" />
                <stop offset=".61" stopColor="#edf4ff" stopOpacity=".53" />
                <stop offset=".75" stopColor="#f4f8ff" stopOpacity=".32" />
                <stop offset=".89" stopColor="#fcfdff" stopOpacity=".08" />
                <stop offset=".94" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="g23"
                x2="1"
                href="#P"
                gradientTransform="matrix(-283.61,-355.82,355.904,-283.677,874.64,496.47)"
            >
                <stop stopColor="#deebff" stopOpacity="1" />
                <stop offset=".1" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".22" stopColor="#e0ecff" stopOpacity=".92" />
                <stop offset=".34" stopColor="#e3eeff" stopOpacity=".83" />
                <stop offset=".47" stopColor="#e7f1ff" stopOpacity=".7" />
                <stop offset=".61" stopColor="#edf4ff" stopOpacity=".53" />
                <stop offset=".75" stopColor="#f4f8ff" stopOpacity=".32" />
                <stop offset=".89" stopColor="#fcfdff" stopOpacity=".08" />
                <stop offset=".94" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="g24"
                x2="1"
                href="#P"
                gradientTransform="matrix(-283.61,-355.82,355.904,-283.677,795.3,559.7)"
            >
                <stop stopColor="#deebff" stopOpacity="1" />
                <stop offset=".1" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".22" stopColor="#e0ecff" stopOpacity=".92" />
                <stop offset=".34" stopColor="#e3eeff" stopOpacity=".83" />
                <stop offset=".47" stopColor="#e7f1ff" stopOpacity=".7" />
                <stop offset=".61" stopColor="#edf4ff" stopOpacity=".53" />
                <stop offset=".75" stopColor="#f4f8ff" stopOpacity=".32" />
                <stop offset=".89" stopColor="#fcfdff" stopOpacity=".08" />
                <stop offset=".94" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="g25"
                x2="1"
                href="#P"
                gradientTransform="matrix(-283.61,-355.81,355.894,-283.677,782.18,570.16)"
            >
                <stop stopColor="#deebff" stopOpacity="1" />
                <stop offset=".1" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".22" stopColor="#e0ecff" stopOpacity=".92" />
                <stop offset=".34" stopColor="#e3eeff" stopOpacity=".83" />
                <stop offset=".47" stopColor="#e7f1ff" stopOpacity=".7" />
                <stop offset=".61" stopColor="#edf4ff" stopOpacity=".53" />
                <stop offset=".75" stopColor="#f4f8ff" stopOpacity=".32" />
                <stop offset=".89" stopColor="#fcfdff" stopOpacity=".08" />
                <stop offset=".94" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="g26"
                x2="1"
                href="#P"
                gradientTransform="matrix(-283.62,-355.82,355.948,-283.722,888.1,485.74)"
            >
                <stop stopColor="#deebff" stopOpacity="1" />
                <stop offset=".1" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".22" stopColor="#e0ecff" stopOpacity=".92" />
                <stop offset=".34" stopColor="#e3eeff" stopOpacity=".83" />
                <stop offset=".47" stopColor="#e7f1ff" stopOpacity=".7" />
                <stop offset=".61" stopColor="#edf4ff" stopOpacity=".53" />
                <stop offset=".75" stopColor="#f4f8ff" stopOpacity=".32" />
                <stop offset=".89" stopColor="#fcfdff" stopOpacity=".08" />
                <stop offset=".94" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="g27"
                x2="1"
                href="#P"
                gradientTransform="matrix(-283.61,-355.82,355.948,-283.712,847.42,518.16)"
            >
                <stop stopColor="#deebff" stopOpacity="1" />
                <stop offset=".1" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".22" stopColor="#e0ecff" stopOpacity=".92" />
                <stop offset=".34" stopColor="#e3eeff" stopOpacity=".83" />
                <stop offset=".47" stopColor="#e7f1ff" stopOpacity=".7" />
                <stop offset=".61" stopColor="#edf4ff" stopOpacity=".53" />
                <stop offset=".75" stopColor="#f4f8ff" stopOpacity=".32" />
                <stop offset=".89" stopColor="#fcfdff" stopOpacity=".08" />
                <stop offset=".94" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="g28"
                x2="1"
                href="#P"
                gradientTransform="matrix(-283.61,-355.82,355.948,-283.712,834.87,528.17)"
            >
                <stop stopColor="#deebff" stopOpacity="1" />
                <stop offset=".1" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".22" stopColor="#e0ecff" stopOpacity=".92" />
                <stop offset=".34" stopColor="#e3eeff" stopOpacity=".83" />
                <stop offset=".47" stopColor="#e7f1ff" stopOpacity=".7" />
                <stop offset=".61" stopColor="#edf4ff" stopOpacity=".53" />
                <stop offset=".75" stopColor="#f4f8ff" stopOpacity=".32" />
                <stop offset=".89" stopColor="#fcfdff" stopOpacity=".08" />
                <stop offset=".94" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="g29"
                x2="1"
                href="#P"
                gradientTransform="matrix(-283.61,-355.81,355.938,-283.712,822.31,538.17)"
            >
                <stop stopColor="#deebff" stopOpacity="1" />
                <stop offset=".1" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".22" stopColor="#e0ecff" stopOpacity=".92" />
                <stop offset=".34" stopColor="#e3eeff" stopOpacity=".83" />
                <stop offset=".47" stopColor="#e7f1ff" stopOpacity=".7" />
                <stop offset=".61" stopColor="#edf4ff" stopOpacity=".53" />
                <stop offset=".75" stopColor="#f4f8ff" stopOpacity=".32" />
                <stop offset=".89" stopColor="#fcfdff" stopOpacity=".08" />
                <stop offset=".94" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="g30"
                x2="1"
                href="#P"
                gradientTransform="matrix(-283.61,-355.82,355.859,-283.641,769.05,580.63)"
            >
                <stop stopColor="#deebff" stopOpacity="1" />
                <stop offset=".1" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".22" stopColor="#e0ecff" stopOpacity=".92" />
                <stop offset=".34" stopColor="#e3eeff" stopOpacity=".83" />
                <stop offset=".47" stopColor="#e7f1ff" stopOpacity=".7" />
                <stop offset=".61" stopColor="#edf4ff" stopOpacity=".53" />
                <stop offset=".75" stopColor="#f4f8ff" stopOpacity=".32" />
                <stop offset=".89" stopColor="#fcfdff" stopOpacity=".08" />
                <stop offset=".94" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="g31"
                x2="1"
                href="#P"
                gradientTransform="matrix(-283.61,-355.82,355.948,-283.712,809.76,548.18)"
            >
                <stop stopColor="#deebff" stopOpacity="1" />
                <stop offset=".1" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".22" stopColor="#e0ecff" stopOpacity=".92" />
                <stop offset=".34" stopColor="#e3eeff" stopOpacity=".83" />
                <stop offset=".47" stopColor="#e7f1ff" stopOpacity=".7" />
                <stop offset=".61" stopColor="#edf4ff" stopOpacity=".53" />
                <stop offset=".75" stopColor="#f4f8ff" stopOpacity=".32" />
                <stop offset=".89" stopColor="#fcfdff" stopOpacity=".08" />
                <stop offset=".94" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="g32"
                x2="1"
                href="#P"
                gradientTransform="matrix(168.98,-100.7,89.38,149.984,262.22,350.52)"
            >
                <stop offset=".12" stopColor="#2684ff" />
                <stop offset=".53" stopColor="#4c9aff" />
                <stop offset="1" stopColor="#b2d4ff" />
            </linearGradient>
            <linearGradient
                id="g33"
                x2="1"
                href="#P"
                gradientTransform="matrix(-262.04,183.34,-196.442,-280.766,621.52,366.88)"
            >
                <stop offset=".07" stopColor="#fff" />
                <stop offset=".39" stopColor="#fbfcff" />
                <stop offset=".71" stopColor="#eff5ff" />
                <stop offset="1" stopColor="#deebff" />
            </linearGradient>
            <linearGradient
                id="g34"
                x2="1"
                href="#P"
                gradientTransform="matrix(-262.05,183.34,-196.443,-280.779,661.64,424.21)"
            >
                <stop offset=".07" stopColor="#fff" />
                <stop offset=".39" stopColor="#fbfcff" />
                <stop offset=".71" stopColor="#eff5ff" />
                <stop offset="1" stopColor="#deebff" />
            </linearGradient>
            <linearGradient
                id="g35"
                x2="1"
                href="#P"
                gradientTransform="matrix(-262.04,183.34,-174.773,-249.795,562.35,282.3)"
            >
                <stop offset=".07" stopColor="#fff" />
                <stop offset=".39" stopColor="#fbfcff" />
                <stop offset=".71" stopColor="#eff5ff" />
                <stop offset="1" stopColor="#deebff" />
            </linearGradient>
            <linearGradient
                id="g36"
                x2="1"
                href="#P"
                gradientTransform="matrix(-341.78,339.54,-337.905,-340.135,488.43,280.6)"
            >
                <stop offset=".07" stopColor="#fff" />
                <stop offset=".39" stopColor="#fbfcff" />
                <stop offset=".71" stopColor="#eff5ff" />
                <stop offset="1" stopColor="#deebff" />
            </linearGradient>
            <linearGradient
                id="g37"
                x2="1"
                href="#P"
                gradientTransform="matrix(-341.78,339.53,-338.465,-340.707,532.39,324.85)"
            >
                <stop offset=".07" stopColor="#fff" />
                <stop offset=".39" stopColor="#fbfcff" />
                <stop offset=".71" stopColor="#eff5ff" />
                <stop offset="1" stopColor="#deebff" />
            </linearGradient>
            <linearGradient
                id="g38"
                x2="1"
                href="#P"
                gradientTransform="matrix(-341.78,339.53,-338.828,-341.073,558.15,350.78)"
            >
                <stop offset=".07" stopColor="#fff" />
                <stop offset=".39" stopColor="#fbfcff" />
                <stop offset=".71" stopColor="#eff5ff" />
                <stop offset="1" stopColor="#deebff" />
            </linearGradient>
            <linearGradient
                id="g39"
                x2="1"
                href="#P"
                gradientTransform="matrix(-341.79,339.53,-338.46,-340.713,584.01,376.81)"
            >
                <stop offset=".07" stopColor="#fff" />
                <stop offset=".39" stopColor="#fbfcff" />
                <stop offset=".71" stopColor="#eff5ff" />
                <stop offset="1" stopColor="#deebff" />
            </linearGradient>
            <linearGradient
                id="g40"
                x2="1"
                href="#P"
                gradientTransform="matrix(-341.78,339.53,-338.465,-340.707,472.03,264.09)"
            >
                <stop offset=".07" stopColor="#fff" />
                <stop offset=".39" stopColor="#fbfcff" />
                <stop offset=".71" stopColor="#eff5ff" />
                <stop offset="1" stopColor="#deebff" />
            </linearGradient>
            <clipPath clipPathUnits="userSpaceOnUse" id="cp1">
                <path d="m625.65 188.89h-261.14v71.1l219.11-0.55 28.29 30.19 24.52-3.25-10.78-26.94v-70.55z" />
            </clipPath>
            <linearGradient
                id="g41"
                x2="1"
                href="#P"
                gradientTransform="matrix(189.06,-68.43,61.787,170.706,438.361,563.061)"
            >
                <stop offset=".12" stopColor="#2684ff" />
                <stop offset=".53" stopColor="#4c9aff" />
                <stop offset="1" stopColor="#b2d4ff" />
            </linearGradient>
        </defs>
        <style>
            {`
                .s1_a{mix-blend-mode:multiply;fill:url(#g1)}
                .s1_b{fill:none;stroke:#4c9aff;stroke-miterlimit:10;stroke-width:2}
                .s1_c{fill:url(#g2)}
                .s1_d{fill:#deebff}
                .s1_e{opacity:.2;mix-blend-mode:multiply;fill:#deebff}
                .s1_f{fill:#b2d4ff}
                .s1_g{fill:none;stroke:#b2d4ff;stroke-linejoin:round}
                .s1_h{opacity:.3;mix-blend-mode:multiply;fill:#deebff}
                .s1_i{fill:#b3f5ff}
                .s1_j{fill:none;stroke:#fff;stroke-linejoin:round}
                .s1_k{fill:#e6fcff}
                .s1_l{fill:url(#g3)}
                .s1_m{fill:url(#g4)}
                .s1_n{fill:url(#g5)}
                .s1_o{fill:url(#g6)}
                .s1_p{fill:url(#g7)}
                .s1_q{fill:url(#g8)}
                .s1_r{fill:url(#g9)}
                .s1_s{fill:url(#g10)}
                .s1_t{fill:url(#g11)}
                .s1_u{fill:url(#g12)}
                .s1_v{fill:url(#g13)}
                .s1_w{fill:url(#g14)}
                .s1_x{fill:url(#g15)}
                .s1_y{fill:url(#g16)}
                .s1_z{fill:url(#g17)}
                .s1_A{fill:url(#g18)}
                .s1_B{fill:url(#g19)}
                .s1_C{fill:url(#g20)}
                .s1_D{fill:url(#g21)}
                .s1_E{fill:url(#g22)}
                .s1_F{fill:url(#g23)}
                .s1_G{fill:url(#g24)}
                .s1_H{fill:url(#g25)}
                .s1_I{fill:url(#g26)}
                .s1_J{fill:url(#g27)}
                .s1_K{fill:url(#g28)}
                .s1_L{fill:url(#g29)}
                .s1_M{fill:url(#g30)}
                .s1_N{fill:url(#g31)}
                .s1_O{fill:url(#g32)}
                .s1_P{fill:url(#g33)}
                .s1_Q{fill:url(#g34)}
                .s1_R{fill:url(#g35)}
                .s1_S{fill:url(#g36)}
                .s1_T{fill:url(#g37)}
                .s1_U{fill:url(#g38)}
                .s1_V{fill:url(#g39)}
                .s1_W{fill:url(#g40)}
                .s1_X{fill:#e3fcef}
                .s1_Y{fill:none;stroke:#79f2c0;stroke-linejoin:round}
                .s1_Z{fill:#fff}
                .s1_a0{fill:url(#g41)}
                .s1_a1{fill:#2684ff}
                .s1_a2{fill:#fcc6eb}
                .s1_a3{fill:#ed50b4}
                .s1_a4{fill:#fff2fb}
                .s1_a5{fill:#f99cdb}
                .s1_a6{fill:#fec176}
                .s1_a7{fill:#ffe380}
                .s1_a8{fill:#fff0b2}
                .s1_a9{fill:#ffc400}
                .s1_aa{mix-blend-mode:multiply;fill:#deebff}
                .s1_ab{fill:#79f2c0}
            `}
        </style>
        <path
            fillRule="evenodd"
            className="s1_a"
            d="m835.4 67.1v65.8h68.8v1h-68.8v65.7h68.8v1h-68.8v65.8h68.8v1h-68.8v65.8h68.8v1h-68.8v65.8h68.8v1h-68.8v65.8h68.8v1h-68.8v65.7h68.8v1h-68.8v65.8h68.8v1h-68.8v65.8h68.8v1h-68.8v67.7h-1v-67.7h-68.2v67.7h-1v-67.7h-68.2v67.7h-1v-67.7h-68.3v67.7h-1v-67.7h-68.2v67.7h-1v-67.7h-68.2v67.7h-1v-67.7h-68.3v67.7h-1v-67.7h-68.2v67.7h-1v-67.7h-68.2v67.7h-1v-67.7h-68.2v67.7h-1v-67.7h-68.3v67.7h-1v-67.7h-68.2v67.7h-1v-67.7h-68.7v-1h68.7v-65.8h-68.7v-1h68.7v-65.8h-68.7v-1h68.7v-65.7h-68.7v-1h68.7v-65.8h-68.7v-1h68.7v-65.8h-68.7v-1h68.7v-65.8h-68.7v-1h68.7v-65.8h-68.7v-1h68.7v-65.7h-68.7v-1h68.7v-65.8h-68.7v-1h68.7v-66.3h1v66.3h68.2v-66.3h1v66.3h68.3v-66.3h1v66.3h68.2v-66.3h1v66.3h68.2v-66.3h1v66.3h68.2v-66.3h1v66.3h68.3v-66.3h1v66.3h68.2v-66.3h1v66.3h68.2v-66.3h1v66.3h68.3v-66.3h1v66.3h68.2v-66.3h1v66.3h68.2v-66.3h1v66.3h68.8v1c0 0-68.8 0-68.8 0zm-138.4 0v65.8h68.2v-65.8zm-276.9 332.9h68.2v-65.8h-68.2zm-1-65.8h-68.3v65.8h68.3zm70.2 65.8h68.2v-65.8h-68.2zm68.2-66.8v-65.8h-68.2v65.8zm-69.2-65.8h-68.3v65.8h68.3zm-69.3 0h-68.2v65.8h68.2zm-69.2 0h-68.2v65.8h68.2zm-68.2 66.8v65.7h68.2v-65.7zm0 66.7v65.8h68.2v-65.8zm69.3 65.8h68.2v-65.8h-68.2zm69.2 0h68.2v-65.7h-68.2zm69.2 0h68.3v-65.8h-68.3zm69.3 0h68.2v-65.8h-68.2zm68.2-66.8v-65.8h-68.2v65.8zm0-66.8v-65.7h-68.3v65.7zm0-66.7v-65.8h-68.2v65.8zm-69.2-65.8h-68.3v65.8h68.3zm-69.3 0h-68.2v65.7h68.2zm-69.2 0h-68.2v65.8h68.2zm-69.2 0h-68.3v65.8h68.3zm-69.3 0h-68.2v65.8h68.2zm-68.2 66.8v65.7h68.2v-65.7zm0 66.7v65.8h68.3v-65.8zm0 66.8v65.8h68.2v-65.8zm0 66.8v65.8h68.2v-65.8zm69.3 65.8h68.2v-65.8h-68.2zm69.2 0h68.2v-65.8h-68.2zm69.2 0h68.3v-65.8h-68.3zm69.3 0h68.2v-65.7h-68.2zm69.2 0h68.2v-65.8h-68.2zm69.2 0h68.3v-65.8h-68.3zm68.3-66.8v-65.8h-68.3v65.8zm0-66.8v-65.7h-68.2v65.7zm0-66.7v-65.8h-68.2v65.8zm0-66.8v-65.8h-68.3v65.8zm0-66.8v-65.8h-68.2v65.8zm-69.2-65.8h-68.3v65.8h68.3zm-69.3 0h-68.2v65.8h68.2zm-69.2 0h-68.2v65.8h68.2zm-69.2 0h-68.3v65.7h68.3zm-69.3 0h-68.2v65.8h68.2zm-69.2 0h-68.2v65.8h68.2zm-69.2 0h-68.2v65.8h68.2zm-68.2 66.8v65.7h68.2v-65.7zm0 66.7v65.8h68.2v-65.8zm0 66.8v65.8h68.2v-65.8zm0 66.8v65.8h68.3v-65.8zm0 66.8v65.8h68.2v-65.8zm0 66.8v65.7h68.2v-65.7zm69.3 65.7h68.2v-65.7h-68.2zm69.2 0h68.2v-65.8h-68.2zm69.2 0h68.3v-65.8h-68.3zm69.3 0h68.2v-65.8h-68.2zm69.2 0h68.2v-65.8h-68.2zm69.2 0h68.3v-65.7h-68.3zm69.3 0h68.2v-65.8h-68.2zm69.2 0h68.2v-65.8h-68.2zm68.2-66.8v-65.8h-68.2v65.8zm0-66.8v-65.7h-68.2v65.7zm0-66.7v-65.8h-68.3v65.8zm0-66.8v-65.8h-68.2v65.8zm0-66.8v-65.8h-68.2v65.8zm0-66.8v-65.8h-68.3v65.8zm-137.4-132.5v65.7h68.2v-65.7zm-69.2 0v65.7h68.2v-65.7zm-69.2 0v65.7h68.2v-65.7zm-69.2 0v65.7h68.2v-65.7zm-69.2 0v65.7h68.2v-65.7zm-69.2 0v65.7h68.2v-65.7zm-69.2 0v65.7h68.2v-65.7zm-69.2 0v65.7h68.2v-65.7zm-69.2 65.7h68.2v-65.7h-68.2zm0 66.7h68.2v-65.7h-68.2zm0 66.7h68.2v-65.7h-68.2zm0 66.7h68.2v-65.7h-68.2zm0 66.7h68.2v-65.7h-68.2zm0 66.7h68.2v-65.7h-68.2zm0 66.7h68.2v-65.7h-68.2zm0 66.7h68.2v-65.7h-68.2zm68.2 66.7v-65.7h-68.2v65.7zm69.2 0v-65.7h-68.2v65.7zm69.2 0v-65.7h-68.2v65.7zm69.2 0v-65.7h-68.2v65.7zm69.2 0v-65.7h-68.2v65.7zm69.2 0v-65.7h-68.2v65.7zm69.2 0v-65.7h-68.2v65.7zm69.2 0v-65.7h-68.2v65.7zm69.2 0v-65.7h-68.2v65.7zm69.2 0v-65.7h-68.2v65.7zm69.2-65.7h-68.2v65.7h68.2zm0-66.7h-68.2v65.7h68.2zm0-66.7h-68.2v65.7h68.2zm0-66.7h-68.2v65.7h68.2zm0-66.7h-68.2v65.7h68.2zm0-66.7h-68.2v65.7h68.2zm0-66.7h-68.2v65.7h68.2zm0-66.7h-68.2v65.7h68.2zm0-66.7h-68.2v65.7h68.2z"
        />
        <path
            fillRule="evenodd"
            className="s1_b"
            d="m705.2 407.1q0 1.5-0.1 3"
        />
        <path
            fillRule="evenodd"
            className="s1_b"
            d="m704.8 416.2c-3.8 52.9-38.4 103.8-93.6 128.9-56.3 25.7-118.6 17.5-161.1-15.9"
        />
        <path
            fillRule="evenodd"
            className="s1_b"
            d="m447.7 527.3q-1.2-0.9-2.3-1.9"
        />
        <path className="s1_c" d="m473.5 190.2h314.4v315.8h-314.4z" />
        <path
            className="s1_d"
            d="m199.6 138.8h340.9v317.2c0 1.1-0.9 2-2 2h-336.9c-1.1 0-2-0.9-2-2z"
        />
        <path className="s1_e" d="m199.6 166.5h71.2v291.5h-71.2z" />
        <path className="s1_f" d="m199.6 138.8h340.9v27.8h-340.9z" />
        <path className="s1_f" d="m293.2 260h214.8v133.1h-214.8z" />
        <path className="s1_g" d="m296.2 412.4h180.5" />
        <path className="s1_g" d="m296.2 425.8h115.4" />
        <path className="s1_g" d="m296.2 187.4h160.8" />
        <path className="s1_g" d="m296.2 200.8h115.4" />
        <path className="s1_g" d="m344.8 230.8h66.8" />
        <path className="s1_g" d="m344.8 238.3h45.6" />
        <path className="s1_h" d="m389.5 326.6h44.2v27.3h-44.2z" />
        <path className="s1_h" d="m389.5 284.5h44.2v27.3h-44.2z" />
        <path
            className="s1_i"
            d="m632.2 289.6c0-0.5 0.4-1 1-1h35.7c0.5 0 1 0.5 1 1v7.5c0 0.6-0.5 1-1 1h-35.7c-0.6 0-1-0.4-1-1z"
        />
        <g style={{ opacity: 0.5 }}>
            <path className="s1_j" d="m294.5 278.3h212.1" />
            <path className="s1_j" d="m294.5 319.1h212.1" />
            <path className="s1_j" d="m294.5 359.8h212.1" />
            <path className="s1_j" d="m320.4 261.4v130" />
            <path className="s1_j" d="m379.7 261.4v130" />
            <path className="s1_j" d="m444.8 261.4v130" />
        </g>
        <path
            className="s1_i"
            d="m690.8 298.8c-3.5 0-6.4-2.8-6.4-6.3 0-3.5 2.9-6.3 6.4-6.3 3.4 0 6.3 2.8 6.3 6.3 0 3.5-2.9 6.3-6.3 6.3z"
        />
        <path
            className="s1_k"
            d="m693.7 295.8c0.2-0.1 0.3-0.3 0.2-0.5-0.2-0.4-0.3-0.7-0.3-1.1v-2.1q0-0.5-0.1-0.9-0.1-0.1-0.1-0.2 0 0 0 0c-0.2-0.7-0.7-1.3-1.5-1.6-0.8-0.4-1.7-0.4-2.4 0-0.8 0.4-1.3 1.1-1.5 1.9q-0.1 0.4-0.1 0.8v2.1c0 0.4-0.1 0.7-0.3 1.1q0 0.1 0 0.2c0 0.2 0.2 0.4 0.4 0.4h1.3q-0.3 0.4-0.7 0.6-0.9 0.4-1.7 1 0.6 0.5 1.3 0.8l0.2 0.1c0.7 0.3 1.5 0.4 2.4 0.4q1.2 0 2.4-0.4l0.1-0.1q0.7-0.3 1.3-0.7-0.8-0.7-1.6-1-0.5-0.2-0.8-0.7h1.3q0.1 0 0.2 0z"
        />
        <path
            fillRule="evenodd"
            className="s1_l"
            d="m748.5 253v25.7h29.5c0.5 0 1 0.4 1 1 0 0.5-0.5 1-1 1h-29.5v24.9h29.5c0.5 0 1 0.5 1 1 0 0.6-0.5 1-1 1h-29.5v24.9h29.5c0.5 0 1 0.5 1 1 0 0.6-0.5 1-1 1h-29.5v25.7h29.5c0.5 0 1 0.4 1 1 0 0.5-0.5 1-1 1h-29.5v24.9h29.5c0.5 0 1 0.5 1 1 0 0.6-0.5 1-1 1h-29.5v25h29.5c0.5 0 1 0.4 1 1 0 0.5-0.5 1-1 1h-29.5v24.9h29.5c0.5 0 1 0.5 1 1 0 0.6-0.5 1-1 1h-29.5v25.7h29.5c0.5 0 1 0.4 1 1 0 0.5-0.5 1-1 1h-29.5v19.5c0 0.5-0.4 1-1 1-0.5 0-1-0.5-1-1v-19.5h-69.1v19.5c0 0.5-0.4 1-1 1-0.5 0-1-0.5-1-1v-19.5h-48.8v19.5c0 0.5-0.4 1-1 1-0.5 0-1-0.5-1-1v-19.5h-64.1v19.5c0 0.5-0.5 1-1 1-0.6 0-1-0.5-1-1v-19.5h-18c-0.5 0-1-0.5-1-1 0-0.6 0.5-1 1-1h18v-25.7h-18c-0.5 0-1-0.4-1-1 0-0.5 0.5-1 1-1h18v-24.9h-18c-0.5 0-1-0.5-1-1 0-0.6 0.5-1 1-1h18v-25h-18c-0.5 0-1-0.4-1-1 0-0.5 0.5-1 1-1h18v-24.9h-18c-0.5 0-1-0.5-1-1 0-0.6 0.5-1 1-1h18v-25.7h-18c-0.5 0-1-0.4-1-1 0-0.5 0.5-1 1-1h18v-24.9h-18c-0.5 0-1-0.4-1-1 0-0.5 0.5-1 1-1h18v-24.9h-18c-0.5 0-1-0.5-1-1 0-0.6 0.5-1 1-1h18v-25.7h-18c-0.5 0-1-0.4-1-1 0-0.5 0.5-1 1-1h18v-24.9h-18c-0.5 0-1-0.4-1-1 0-0.6 0.5-1 1-1h18v-15.9c0-0.6 0.4-1 1-1 0.5 0 1 0.4 1 1v15.9h64.1v-15.9c0-0.6 0.5-1 1-1 0.6 0 1 0.4 1 1v15.9h48.8v-15.9c0-0.6 0.5-1 1-1 0.6 0 1 0.4 1 1v15.9h69.1v-15.9c0-0.6 0.5-1 1-1 0.6 0 1 0.4 1 1v15.9h29.5c0.5 0 1 0.4 1 1 0 0.6-0.5 1-1 1h-29.5v24.9h29.5c0.5 0 1 0.5 1 1 0 0.6-0.5 1-1 1zm-123.9 190h-64.2v25.6h64.2zm0-26.9h-64.2v24.9h64.2zm0-26.9h-64.2v24.9h64.2zm0-26.9h-64.2v24.9h64.2zm0-27.6h-64.2v25.6h64.2zm0-26.9h-64.2v24.9h64.2zm0-26.9h-64.2v24.9h64.2zm0-27.6h-64.2v25.6h64.2zm0-26.9h-64.2v24.9h64.2zm50.8 216.9h-48.8v25.7h48.8zm0-26.9h-48.8v24.9h48.8zm0-27h-48.8v25h48.8zm0-27h-48.8v25h48.8zm0-27.7h-48.8v25.7h48.8zm0-26.9h-48.8v24.9h48.8zm0-27h-48.8v25h48.8zm0-27.7h-48.8v25.7h48.8zm0-26.9h-48.8v24.9h48.8zm71.1 216.9h-69.1v25.6h69.1zm0-26.9h-69.1v24.9h69.1zm0-26.9h-69.1v24.9h69.1zm0-26.9h-69.1v24.9h69.1zm0-27.6h-69.1v25.6h69.1zm0-26.9h-69.1v24.9h69.1zm0-26.9h-69.1v24.9h69.1zm0-27.6h-69.1v25.6h69.1zm0-26.9h-69.1v24.9h69.1z"
        />
        <path
            className="s1_m"
            d="m632.2 235.3c0-0.6 0.4-1.1 1-1.1h35.7c0.5 0 1 0.5 1 1v7.6c0 0.5-0.5 1-1 1h-35.7c-0.6 0-1-0.5-1-1z"
        />
        <path
            className="s1_n"
            d="m632.2 397.8c0-0.5 0.4-1 1-1h35.7c0.5 0 1 0.5 1 1v7.6c0 0.5-0.5 1-1 1h-35.7c-0.6 0-1-0.5-1-1z"
        />
        <path
            className="s1_o"
            d="m632.2 424.8c0-0.6 0.4-1 1-1h35.7c0.5 0 1 0.4 1 1v7.5c0 0.6-0.5 1-1 1h-35.7c-0.6 0-1-0.4-1-1z"
        />
        <path
            className="s1_p"
            d="m632.2 451.7c0-0.6 0.4-1 1-1h35.7c0.5 0 1 0.4 1 1v7.5c0 0.6-0.5 1-1 1h-35.7c-0.6 0-1-0.4-1-1z"
        />
        <path
            className="s1_q"
            d="m632.2 478.6c0-0.5 0.4-1 1-1h35.7c0.5 0 1 0.5 1 1v7.5c0 0.6-0.5 1-1 1h-35.7c-0.6 0-1-0.4-1-1z"
        />
        <path
            className="s1_r"
            d="m632.2 262c0-0.6 0.4-1 1-1h35.7c0.5 0 1 0.4 1 1v7.5c0 0.6-0.5 1-1 1h-35.7c-0.6 0-1-0.4-1-1z"
        />
        <path
            className="s1_s"
            d="m632.2 370.9c0-0.6 0.4-1 1-1h35.7c0.5 0 1 0.4 1 1v7.5c0 0.6-0.5 1-1 1h-35.7c-0.6 0-1-0.4-1-1z"
        />
        <path
            className="s1_t"
            d="m632.2 317.8c0-0.5 0.4-1 1-1h35.7c0.5 0 1 0.5 1 1v7.6c0 0.5-0.5 1-1 1h-35.7c-0.6 0-1-0.5-1-1z"
        />
        <path
            className="s1_u"
            d="m632.2 343.6c0-0.6 0.4-1 1-1h35.7c0.5 0 1 0.4 1 1v7.5c0 0.6-0.5 1-1 1h-35.7c-0.6 0-1-0.4-1-1z"
        />
        <path
            className="s1_v"
            d="m568.6 240h48.4c0.5 0 1-0.4 1-1 0-0.5-0.5-1-1-1h-48.4c-0.5 0-1 0.5-1 1 0 0.6 0.5 1 1 1z"
        />
        <path
            className="s1_w"
            d="m568.6 266.8h48.4c0.5 0 1-0.5 1-1 0-0.6-0.5-1-1-1h-48.4c-0.5 0-1 0.4-1 1 0 0.5 0.5 1 1 1z"
        />
        <path
            className="s1_x"
            d="m568.6 293.5h48.4c0.5 0 1-0.4 1-1 0-0.5-0.5-1-1-1h-48.4c-0.5 0-1 0.5-1 1 0 0.6 0.5 1 1 1z"
        />
        <path
            className="s1_y"
            d="m568.6 320.3h48.4c0.5 0 1-0.5 1-1 0-0.6-0.5-1-1-1h-48.4c-0.5 0-1 0.4-1 1 0 0.5 0.5 1 1 1z"
        />
        <path
            className="s1_z"
            d="m568.6 347h48.4c0.5 0 1-0.4 1-1 0-0.6-0.5-1-1-1h-48.4c-0.5 0-1 0.4-1 1 0 0.6 0.5 1 1 1z"
        />
        <path
            className="s1_A"
            d="m568.6 373.8l48.4-0.1c0.5 0 1-0.4 1-1 0-0.5-0.5-1-1-1h-48.4c-0.5 0-1 0.5-1 1 0 0.6 0.5 1 1 1z"
        />
        <path
            className="s1_B"
            d="m568.6 400.5h48.4c0.5 0 1-0.5 1-1 0-0.6-0.5-1-1-1h-48.4c-0.5 0-1 0.4-1 1 0 0.5 0.5 1 1 1z"
        />
        <path
            className="s1_C"
            d="m568.6 427.2h48.4c0.5 0 1-0.4 1-1 0-0.5-0.5-1-1-1h-48.4c-0.5 0-1 0.5-1 1 0 0.6 0.5 1 1 1z"
        />
        <path
            className="s1_D"
            d="m568.6 454h48.4c0.5 0 1-0.5 1-1 0-0.6-0.5-1-1-1h-48.4c-0.5 0-1 0.4-1 1 0 0.5 0.5 1 1 1z"
        />
        <path
            className="s1_E"
            d="m617 478.7h-48.4c-0.5 0-1 0.5-1 1 0 0.6 0.5 1 1 1h48.4c0.5 0 1-0.4 1-1 0-0.5-0.5-1-1-1z"
        />
        <path
            className="s1_F"
            d="m686.9 270.8q0.3 0.2 0.6 0.4 0 0 0 0 0.3 0.2 0.7 0.3 0.1 0.1 0.1 0.1 0.6 0.2 1.2 0.4 0 0 0.1 0 0.2 0 0.5 0.1 0.3 0 0.6 0 0.3 0 0.7 0 0.2-0.1 0.5-0.1 0 0 0.1 0 1-0.2 1.9-0.8 0 0 0.1 0 0.3-0.2 0.5-0.4c1.6-1.1 2.5-3 2.5-5 0-3.5-2.8-6.3-6.3-6.3-3.5 0-6.3 2.8-6.3 6.3 0 2 1 3.9 2.5 5z"
        />
        <path
            className="s1_G"
            d="m686.9 433.6q0.3 0.2 0.6 0.3 0 0.1 0 0.1 0.3 0.1 0.7 0.3 0.6 0.3 1.3 0.4 0 0 0.1 0 0.2 0.1 0.5 0.1 0.3 0 0.6 0 0.4 0 0.7 0 0.3 0 0.5-0.1 0.1 0 0.1 0 1.1-0.2 1.9-0.7 0.1 0 0.1 0 0.3-0.2 0.6-0.4c1.5-1.2 2.5-3 2.5-5.1 0-3.4-2.9-6.3-6.4-6.3-3.4 0-6.3 2.9-6.3 6.3 0 2.1 1 3.9 2.5 5.1z"
        />
        <path
            className="s1_H"
            d="m686.9 460.5q0.3 0.2 0.6 0.4 0 0 0 0 0.3 0.2 0.7 0.3 0.1 0.1 0.1 0.1 0.6 0.2 1.2 0.4 0 0 0.1 0 0.2 0 0.5 0.1 0.3 0 0.6 0 0.3 0 0.7 0 0.2-0.1 0.5-0.1 0 0 0.1 0 1-0.2 1.9-0.8 0 0 0.1 0 0.3-0.2 0.5-0.4c1.6-1.1 2.5-3 2.5-5 0-3.5-2.8-6.3-6.3-6.3-3.5 0-6.3 2.8-6.3 6.3 0 2 1 3.9 2.5 5z"
        />
        <path
            className="s1_I"
            d="m687.2 243.4q0.4 0.2 0.7 0.4 0.1 0 0.2 0.1 0.4 0.2 0.8 0.3 0.4 0.1 0.8 0.2 0.1 0 0.2 0 0.4 0.1 0.8 0.1 0.5 0 0.9-0.1 0.1 0 0.2 0 0.4-0.1 0.8-0.2 0.4-0.1 0.8-0.3 0-0.1 0.1-0.1 0.4-0.2 0.7-0.4c1.7-1.1 2.8-3.1 2.8-5.3 0-3.4-2.8-6.3-6.3-6.3-3.5 0-6.3 2.9-6.3 6.3 0 2.2 1.1 4.2 2.8 5.3z"
        />
        <path
            className="s1_J"
            d="m687.2 326.9q0.4 0.2 0.7 0.4 0.1 0 0.2 0 0.4 0.2 0.8 0.3 0.4 0.1 0.8 0.2 0.1 0 0.2 0 0.4 0.1 0.8 0.1 0.5 0 0.9-0.1 0.1 0 0.2 0 0.4 0 0.8-0.2 0.4-0.1 0.8-0.3 0 0 0.1 0 0.4-0.2 0.7-0.4c1.7-1.2 2.8-3.1 2.8-5.3 0-3.5-2.8-6.3-6.3-6.3-3.5 0-6.3 2.8-6.3 6.3 0 2.2 1.1 4.1 2.8 5.3z"
        />
        <path
            className="s1_K"
            d="m687.2 352.6q0.4 0.2 0.7 0.4 0.1 0 0.2 0.1 0.4 0.2 0.8 0.3 0.4 0.1 0.8 0.2 0.1 0 0.2 0 0.4 0.1 0.8 0.1 0.5 0 0.9-0.1 0.1 0 0.2 0 0.4-0.1 0.8-0.2 0.4-0.1 0.8-0.3 0-0.1 0.1-0.1 0.4-0.2 0.7-0.4c1.7-1.1 2.8-3.1 2.8-5.3 0-3.4-2.8-6.3-6.3-6.3-3.5 0-6.3 2.9-6.3 6.3 0 2.2 1.1 4.2 2.8 5.3z"
        />
        <path
            className="s1_L"
            d="m687.2 378.4q0.4 0.2 0.7 0.4 0.1 0 0.2 0 0.4 0.2 0.8 0.3 0.4 0.2 0.8 0.2 0.1 0 0.2 0.1 0.4 0 0.8 0 0.5 0 0.9 0 0.1 0 0.2-0.1 0.4 0 0.8-0.2 0.4-0.1 0.8-0.3 0 0 0.1 0 0.4-0.2 0.7-0.4c1.7-1.2 2.8-3.1 2.8-5.3 0-3.5-2.8-6.3-6.3-6.3-3.5 0-6.3 2.8-6.3 6.3 0 2.2 1.1 4.1 2.8 5.3z"
        />
        <path
            className="s1_M"
            d="m690.8 476.1c-3.5 0-6.4 2.8-6.4 6.3 0 2.2 1.1 4.1 2.8 5.2q0.4 0.3 0.7 0.4 0.1 0.1 0.2 0.1 0.4 0.2 0.8 0.3 0.4 0.1 0.8 0.2 0.1 0 0.2 0 0.4 0.1 0.8 0.1 0.5 0 0.9-0.1 0.1 0 0.2 0 0.4-0.1 0.8-0.2 0.4-0.1 0.8-0.3 0.1 0 0.1-0.1 0.4-0.1 0.7-0.4c1.7-1.1 2.8-3 2.8-5.2 0-3.5-2.8-6.3-6.3-6.3z"
        />
        <path
            className="s1_N"
            d="m687.2 404.1q0.4 0.3 0.7 0.4 0.1 0.1 0.2 0.1 0.4 0.2 0.8 0.3 0.4 0.1 0.8 0.2 0.1 0 0.2 0 0.4 0.1 0.8 0.1 0.5 0 0.9-0.1 0.1 0 0.2 0 0.4-0.1 0.8-0.2 0.4-0.1 0.8-0.3 0 0 0.1-0.1 0.4-0.1 0.7-0.4c1.7-1.1 2.8-3 2.8-5.2 0-3.5-2.8-6.3-6.3-6.3-3.5 0-6.3 2.8-6.3 6.3 0 2.2 1.1 4.1 2.8 5.2z"
        />
        <path
            className="s1_f"
            d="m301.9 240.8c-3.5 0-6.4-2.9-6.4-6.4 0-3.4 2.9-6.3 6.4-6.3 3.5 0 6.3 2.9 6.3 6.3 0 3.5-2.8 6.4-6.3 6.4z"
        />
        <path
            className="s1_d"
            d="m304.8 237.8c0.2-0.1 0.3-0.3 0.2-0.5-0.1-0.4-0.3-0.8-0.3-1.2v-2.1q0-0.4-0.1-0.8-0.1-0.1-0.1-0.3 0 0 0 0c-0.2-0.6-0.7-1.2-1.5-1.6-0.8-0.3-1.7-0.4-2.4 0-0.8 0.5-1.3 1.2-1.5 1.9q-0.1 0.4-0.1 0.8v2.1c0 0.4-0.1 0.8-0.3 1.1q0 0.1 0 0.2c0 0.2 0.2 0.4 0.4 0.4h1.3q-0.2 0.5-0.7 0.7-0.9 0.4-1.6 1 0.5 0.4 1.2 0.7l0.2 0.1c0.7 0.3 1.5 0.5 2.4 0.5q1.3 0 2.4-0.5h0.1q0.7-0.3 1.3-0.8-0.7-0.6-1.6-1-0.5-0.2-0.7-0.6h1.2q0.1 0 0.2-0.1z"
        />
        <path
            className="s1_f"
            d="m316.8 240.8c-3.5 0-6.3-2.9-6.3-6.4 0-3.4 2.8-6.3 6.3-6.3 3.5 0 6.3 2.9 6.3 6.3 0 3.5-2.8 6.4-6.3 6.4z"
        />
        <path
            className="s1_d"
            d="m318.4 232.2c-0.8-0.6-1.9-0.7-2.7-0.3-1.7 0.8-2.1 2.9-1 4.3q0.2 0.1 0.4 0.3c0.3 0.3 0.5 0.7 0.5 1.1 0 0.6-0.4 1.1-0.9 1.3q-0.8 0.3-1.4 0.8c1 0.7 2.2 1.1 3.5 1.1 1.3 0 2.5-0.4 3.5-1.1q-0.6-0.5-1.4-0.8c-0.5-0.2-0.8-0.7-0.8-1.3 0-0.4 0.1-0.8 0.4-1.1 1.4-1.1 1.4-3.2-0.1-4.3z"
        />
        <path className="s1_O" d="m328 284.5h44.2v27.3h-44.2z" />
        <path
            className="s1_P"
            d="m282 481.8c0-1.1 0.9-2 2-2h110.3c1.1 0 2 0.9 2 2v165.2c0 1.1-0.9 2-2 2h-110.3c-1.1 0-2-0.9-2-2z"
        />
        <path
            className="s1_f"
            d="m386.7 489.2c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2 1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
        />
        <path
            className="s1_f"
            d="m379.7 489.2c-1.1 0-1.9-0.9-1.9-2 0-1.1 0.8-1.9 1.9-1.9 1.1 0 2 0.8 2 1.9 0 1.1-0.9 2-2 2z"
        />
        <path
            className="s1_f"
            d="m372.8 489.3c-1.1-0.1-2-0.9-2-2 0-1.1 0.9-2 2-2 1.1 0 1.9 0.9 1.9 2 0 1.1-0.8 1.9-1.9 1.9z"
        />
        <path
            className="s1_f"
            d="m290.9 486.1c0-0.6 0.5-1.1 1.1-1.1h33.5c0.6 0 1.1 0.5 1.1 1.1v2.2c0 0.7-0.5 1.1-1.1 1.1h-33.5c-0.6 0-1.1-0.4-1.1-1.1z"
        />
        <path
            className="s1_Q"
            d="m404.1 481.8c0-1.1 0.9-2 2-2h110.3c1.1 0 2 0.9 2 2v165.2c0 1.1-0.9 2-2 2h-110.3c-1.1 0-2-0.9-2-2z"
        />
        <path
            className="s1_f"
            d="m508.8 489.2c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 1.9-2 1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
        />
        <path
            className="s1_f"
            d="m501.8 489.2c-1.1 0-2-0.9-2-2 0-1.1 0.9-1.9 2-1.9 1.1 0 2 0.8 2 1.9 0 1.1-0.9 2-2 2z"
        />
        <path
            className="s1_f"
            d="m494.8 489.3c-1.1-0.1-2-0.9-2-2 0-1.1 0.9-2 2-2 1.1 0 2 0.9 2 2 0 1.1-0.9 1.9-2 1.9z"
        />
        <path
            className="s1_f"
            d="m413 486.1c0-0.6 0.5-1.1 1.1-1.1h33.5c0.6 0 1.1 0.5 1.1 1.1v2.2c0 0.7-0.5 1.1-1.1 1.1h-33.5c-0.6 0-1.1-0.4-1.1-1.1z"
        />
        <g style={{ opacity: 0.5 }}>
            <path
                className="s1_f"
                d="m410 500.3c0-1.1 0.9-2 2-2h98.4c1.1 0 2 0.9 2 2v69.4c0 1.2-0.9 2-2 2h-98.4c-1.1 0-2-0.8-2-2z"
            />
        </g>
        <path
            className="s1_R"
            d="m160.5 481.8c0-1.1 0.9-2 2-2h110.3c1.1 0 2 0.9 2 2v83.3c0 1.1-0.9 2-2 2h-110.3c-1.1 0-2-0.9-2-2z"
        />
        <path
            className="s1_f"
            d="m265.2 489.2c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2 1.1 0 1.9 0.9 1.9 2 0 1.1-0.8 2-1.9 2z"
        />
        <path
            className="s1_f"
            d="m258.2 489.2c-1.1 0-2-0.9-2-2 0-1.1 0.9-1.9 2-1.9 1.1 0 2 0.8 2 1.9 0 1.1-0.9 2-2 2z"
        />
        <path
            className="s1_f"
            d="m251.2 489.3c-1.1-0.1-1.9-0.9-1.9-2 0-1.1 0.8-2 1.9-2 1.1 0 2 0.9 2 2 0 1.1-0.9 1.9-2 1.9z"
        />
        <path
            className="s1_f"
            d="m169.4 486.1c0-0.6 0.5-1.1 1.1-1.1h33.5c0.6 0 1.1 0.5 1.1 1.1v2.2c0 0.7-0.5 1.1-1.1 1.1h-33.5c-0.6 0-1.1-0.4-1.1-1.1z"
        />
        <path
            className="s1_S"
            d="m166.4 543.3c0-1.1 0.9-2 2-2h98.4c1.1 0 2 0.9 2 2v12.7c0 1.1-0.9 2-2 2h-98.4c-1.1 0-2-0.9-2-2z"
        />
        <path className="s1_g" d="m177.5 549.7h56.7" />
        <path
            className="s1_T"
            d="m287.9 500.3c0-1.1 0.9-2 2-2h98.4c1.1 0 2 0.9 2 2v33.1c0 1.1-0.9 2-2 2h-98.4c-1.1 0-2-0.9-2-2z"
        />
        <path className="s1_g" d="m299 512h56.8" />
        <path className="s1_g" d="m299 521.7h56.8" />
        <path
            className="s1_d"
            d="m375.1 522.8c-3.5 0-6.3-2.8-6.3-6.3 0-3.5 2.8-6.3 6.3-6.3 3.5 0 6.3 2.8 6.3 6.3 0 3.5-2.8 6.3-6.3 6.3z"
        />
        <path
            className="s1_f"
            d="m378.1 519.8c0.1-0.1 0.2-0.3 0.1-0.5-0.1-0.4-0.2-0.7-0.2-1.1v-2.1q0-0.5-0.2-0.9 0-0.1 0-0.2 0 0 0 0c-0.3-0.7-0.7-1.3-1.5-1.6-0.8-0.4-1.7-0.4-2.5 0-0.8 0.4-1.2 1.1-1.4 1.9q-0.1 0.4-0.1 0.8v2.1c0 0.4-0.1 0.7-0.3 1.1q0 0.1 0 0.2c0 0.2 0.1 0.4 0.4 0.4h1.2q-0.2 0.4-0.7 0.6-0.9 0.4-1.6 1 0.6 0.5 1.2 0.8l0.2 0.1c0.8 0.3 1.6 0.4 2.4 0.4q1.3 0 2.4-0.4l0.2-0.1q0.7-0.3 1.2-0.7-0.7-0.7-1.6-1-0.4-0.2-0.7-0.7h1.3q0.1 0 0.2 0z"
        />
        <path
            className="s1_U"
            d="m287.9 543.3c0-1.1 0.9-2 2-2h98.4c1.1 0 2 0.9 2 2v50.1c0 1.1-0.9 2-2 2h-98.4c-1.1 0-2-0.9-2-2z"
        />
        <path className="s1_g" d="m299 555h80.7" />
        <path className="s1_g" d="m299 564.8h80.7" />
        <path className="s1_g" d="m299 574.5h43.2" />
        <path
            className="s1_d"
            d="m375.1 588.1c-3.5 0-6.3-2.8-6.3-6.3 0-3.5 2.8-6.3 6.3-6.3 3.5 0 6.3 2.8 6.3 6.3 0 3.5-2.8 6.3-6.3 6.3z"
        />
        <path
            className="s1_f"
            d="m378.1 585.1c0.1-0.1 0.2-0.3 0.1-0.5-0.1-0.4-0.2-0.8-0.2-1.1v-2.1q0-0.5-0.2-0.9 0-0.1 0-0.2 0 0 0 0c-0.3-0.7-0.7-1.3-1.5-1.7-0.8-0.3-1.7-0.3-2.5 0.1-0.8 0.4-1.2 1.1-1.4 1.9q-0.1 0.4-0.1 0.8v2c0 0.4-0.1 0.8-0.3 1.2q0 0.1 0 0.1c0 0.3 0.1 0.5 0.4 0.5h1.2q-0.2 0.4-0.7 0.6-0.9 0.4-1.6 1 0.6 0.5 1.2 0.8l0.2 0.1c0.8 0.3 1.6 0.4 2.4 0.4q1.3 0 2.4-0.4l0.2-0.1q0.7-0.3 1.2-0.8-0.7-0.6-1.6-1-0.4-0.2-0.7-0.6h1.3q0.1 0 0.2-0.1z"
        />
        <path
            className="s1_d"
            d="m355.1 588.1c-3.5 0-6.3-2.8-6.3-6.3 0-3.5 2.8-6.3 6.3-6.3 3.5 0 6.3 2.8 6.3 6.3 0 3.5-2.8 6.3-6.3 6.3z"
        />
        <path
            className="s1_f"
            d="m356.6 579.5c-0.7-0.5-1.8-0.6-2.6-0.2-1.7 0.8-2.1 2.9-1 4.2q0.2 0.2 0.3 0.3c0.3 0.3 0.5 0.7 0.5 1.1 0 0.6-0.3 1.1-0.8 1.3q-0.8 0.3-1.4 0.9c1 0.6 2.2 1 3.5 1 1.3 0 2.5-0.4 3.5-1q-0.6-0.6-1.4-0.9c-0.5-0.2-0.9-0.7-0.9-1.3 0-0.4 0.2-0.8 0.5-1.1 1.3-1.1 1.3-3.2-0.2-4.3z"
        />
        <path
            className="s1_V"
            d="m287.9 603.5c0-1.1 0.9-2 2-2h98.4c1.1 0 2 0.9 2 2v33.1c0 1.2-0.9 2-2 2h-98.4c-1.1 0-2-0.8-2-2z"
        />
        <path className="s1_g" d="m299 615.2h56.8" />
        <path className="s1_g" d="m299 625h56.8" />
        <path
            className="s1_d"
            d="m374.8 627.6c-3.5 0-6.4-2.8-6.4-6.3 0-3.5 2.9-6.3 6.3-6.3 3.5 0 6.4 2.8 6.4 6.3 0 3.5-2.9 6.3-6.4 6.3z"
        />
        <path
            className="s1_f"
            d="m376.3 619.1c-0.8-0.6-1.8-0.7-2.7-0.3-1.7 0.8-2 2.9-0.9 4.2q0.1 0.2 0.3 0.4c0.3 0.2 0.5 0.6 0.5 1.1 0 0.5-0.3 1.1-0.9 1.3q-0.7 0.3-1.4 0.8c1 0.7 2.2 1.1 3.5 1.1 1.4 0 2.6-0.4 3.6-1.1q-0.7-0.5-1.4-0.8c-0.6-0.3-0.9-0.8-0.9-1.4 0-0.4 0.2-0.8 0.5-1 1.3-1.1 1.3-3.3-0.2-4.3z"
        />
        <path
            className="s1_W"
            d="m166.4 500.3c0-1.1 0.9-2 2-2h98.4c1.1 0 2 0.9 2 2v33.1c0 1.1-0.9 2-2 2h-98.4c-1.1 0-2-0.9-2-2z"
        />
        <path className="s1_g" d="m177.5 512h56.7" />
        <path className="s1_g" d="m177.5 521.7h56.7" />
        <path
            className="s1_d"
            d="m253.2 524.3c-3.5 0-6.3-2.8-6.3-6.3 0-3.5 2.8-6.4 6.3-6.4 3.5 0 6.3 2.9 6.3 6.4 0 3.5-2.8 6.3-6.3 6.3z"
        />
        <path
            className="s1_f"
            d="m254.8 515.7c-0.8-0.6-1.8-0.6-2.7-0.3-1.7 0.8-2.1 2.9-1 4.3q0.2 0.1 0.4 0.3c0.3 0.3 0.5 0.7 0.5 1.1 0 0.6-0.4 1.1-0.9 1.3q-0.8 0.3-1.4 0.8c1 0.7 2.2 1.1 3.5 1.1 1.3 0 2.5-0.4 3.5-1.1q-0.6-0.5-1.3-0.8c-0.6-0.2-0.9-0.7-0.9-1.3 0-0.4 0.1-0.8 0.5-1.1 1.3-1.1 1.3-3.2-0.2-4.3z"
        />
        <path
            className="s1_X"
            d="m592.8 292.1l126.3-16.7 3.6 26.7-126.4 16.7z"
        />
        <path className="s1_Y" d="m603.7 299.9l93.7-12.4" />
        <path className="s1_Y" d="m604.9 309.2l73.1-9.7" />
        <g clipPath="url(#cp1)">
            <path
                fillRule="evenodd"
                className="s1_b"
                d="m350.1 301q0.6-1.4 1.3-2.7"
            />
            <path
                fillRule="evenodd"
                className="s1_b"
                d="m354.2 292.9c25.4-46.6 77.9-78.6 138.6-78.6 60.7 0 115.2 33.3 140.1 81.3"
            />
            <path
                fillRule="evenodd"
                className="s1_b"
                d="m634.2 298.3q0.7 1.3 1.3 2.7"
            />
        </g>
        <path
            className="s1_Z"
            d="m472.8 505.3c0.3-1 1.4-1.6 2.5-1.3l79.9 23.1c1.1 0.3 1.7 1.4 1.4 2.5l-17.2 59.2c-0.3 1.1-1.4 1.7-2.5 1.4l-79.9-23.1c-1-0.3-1.6-1.5-1.3-2.5z"
        />
        <path
            className="s1_a0"
            d="m475.3 504l79.9 23.1c1.1 0.3 1.7 1.5 1.4 2.5l-11.9 41.1-83.8-24.3 11.9-41.1c0.3-1 1.4-1.6 2.5-1.3z"
        />
        <path className="s1_a1" d="m472.9 544.5l4.2-14.6 12.7 3.7-4.2 14.6z" />
        <path className="s1_a1" d="m505.7 554l5.9-20.6 12.7 3.6-6 20.6z" />
        <path className="s1_a1" d="m489.3 549.2l8.8-30.2 12.6 3.6-8.7 30.3z" />
        <path className="s1_a1" d="m522 558.7l8.8-30.3 12.6 3.7-8.7 30.3z" />
        <path className="s1_g" d="m470.4 559.6l45.3 13.1" />
        <path
            className="s1_d"
            d="m528.7 583.5c-3.5 0-6.3-2.8-6.3-6.3 0-3.5 2.8-6.3 6.3-6.3 3.5 0 6.3 2.8 6.3 6.3 0 3.5-2.8 6.3-6.3 6.3z"
        />
        <path
            className="s1_f"
            d="m530.8 575.5c-0.6-0.8-1.5-1.2-2.5-1-1.8 0.3-2.8 2.2-2.1 3.8q0.1 0.2 0.3 0.4c0.2 0.3 0.3 0.7 0.1 1.2-0.1 0.5-0.6 0.9-1.2 1q-0.8 0.1-1.5 0.4c0.7 0.9 1.8 1.6 3 2 1.3 0.3 2.6 0.3 3.7-0.1q-0.5-0.6-1.1-1.1c-0.4-0.4-0.6-1-0.5-1.5 0.1-0.4 0.4-0.8 0.8-0.9 1.6-0.7 2.2-2.8 1-4.2z"
        />
        <path
            className="s1_f"
            d="m221.5 203.5c-3.5 0-6.3-2.8-6.3-6.3 0-3.5 2.8-6.4 6.3-6.4 3.5 0 6.3 2.9 6.3 6.4 0 3.5-2.8 6.3-6.3 6.3z"
        />
        <path
            className="s1_d"
            d="m223.1 194.9c-0.8-0.6-1.9-0.7-2.7-0.3-1.7 0.8-2.1 2.9-1 4.3q0.2 0.1 0.4 0.3c0.3 0.3 0.5 0.7 0.5 1.1 0 0.6-0.4 1.1-0.9 1.3q-0.8 0.3-1.4 0.8c1 0.7 2.2 1.1 3.5 1.1 1.3 0 2.5-0.4 3.5-1.1q-0.6-0.5-1.4-0.8c-0.5-0.2-0.9-0.7-0.9-1.3 0-0.4 0.2-0.8 0.5-1.1 1.4-1.1 1.4-3.2-0.1-4.3z"
        />
        <g style={{ opacity: 0.5 }}>
            <path
                className="s1_f"
                d="m222.9 228.8h-4.7c-0.4 0-0.8-0.2-1.1-0.4-0.2-0.3-0.4-0.7-0.4-1.1v-4.6c0-0.4 0.2-0.8 0.4-1.1 0.3-0.3 0.7-0.5 1.1-0.5h4.7c0.4 0 0.8 0.2 1.1 0.5 0.3 0.3 0.5 0.7 0.5 1.1v4.6c0 0.4-0.2 0.8-0.5 1.1-0.3 0.2-0.7 0.4-1.1 0.4z"
            />
            <path className="s1_g" d="m228.5 225h23.1" />
        </g>
        <g style={{ opacity: 0.5 }}>
            <path
                className="s1_f"
                d="m222.9 249.4h-4.7c-0.4 0-0.8-0.1-1.1-0.4-0.2-0.3-0.4-0.7-0.4-1.1v-4.6c0-0.4 0.2-0.8 0.4-1.1 0.3-0.3 0.7-0.4 1.1-0.4h4.7c0.4 0 0.8 0.1 1.1 0.4 0.3 0.3 0.5 0.7 0.5 1.1v4.6c0 0.4-0.2 0.8-0.5 1.1-0.3 0.3-0.7 0.4-1.1 0.4z"
            />
            <path className="s1_g" d="m228.5 245.6h23.1" />
        </g>
        <g style={{ opacity: 0.5 }}>
            <path
                className="s1_f"
                d="m222.9 270.1h-4.7c-0.4 0-0.8-0.2-1.1-0.5-0.2-0.3-0.4-0.7-0.4-1.1v-4.6c0-0.4 0.2-0.8 0.4-1 0.3-0.3 0.7-0.5 1.1-0.5h4.7c0.4 0 0.8 0.2 1.1 0.5 0.3 0.3 0.5 0.6 0.5 1v4.6c0 0.5-0.2 0.9-0.5 1.1-0.3 0.3-0.7 0.5-1.1 0.5z"
            />
            <path className="s1_g" d="m228.5 266.2h23.1" />
        </g>
        <g style={{ opacity: 0.5 }}>
            <path
                className="s1_f"
                d="m222.9 290.7h-4.7c-0.4 0-0.8-0.1-1.1-0.4-0.2-0.3-0.4-0.7-0.4-1.1v-4.6c0-0.4 0.2-0.8 0.4-1.1 0.3-0.3 0.7-0.4 1.1-0.4h4.7c0.4 0 0.8 0.1 1.1 0.4 0.3 0.3 0.5 0.7 0.5 1.1v4.6c0 0.4-0.2 0.8-0.5 1.1-0.3 0.3-0.7 0.4-1.1 0.4z"
            />
            <path className="s1_g" d="m228.5 286.9h23.1" />
        </g>
        <g style={{ opacity: 0.5 }}>
            <path
                className="s1_f"
                d="m222.9 311.4h-4.7c-0.4 0-0.8-0.2-1.1-0.5-0.2-0.3-0.4-0.7-0.4-1.1v-4.6c0-0.4 0.2-0.8 0.4-1 0.3-0.3 0.7-0.5 1.1-0.5h4.7c0.4 0 0.8 0.2 1.1 0.5 0.3 0.2 0.5 0.6 0.5 1v4.6c0 0.4-0.2 0.8-0.5 1.1-0.3 0.3-0.7 0.5-1.1 0.5z"
            />
            <path className="s1_g" d="m228.5 307.5h23.1" />
        </g>
        <path className="s1_a2" d="m602.1 144h60v60h-60z" />
        <path
            className="s1_a3"
            d="m621 186.8c1.3 0.1 3.4-0.4 5.7-1.7l0.2 3.2-2.5 2.8c-2.9 0.7-5.7 1.9-8.2 3.6-1.7 1.1-3.2 3.8-4.3 7.2 0.7-10.3 3.9-7.7 4.9-15.9 0.2-1.8-0.3-4.8-0.8-8.1 1.7 3.3 2.6 4 2.6 5.3 0.1 1.4-0.1 3.5 2.4 3.6z"
        />
        <path
            className="s1_a4"
            d="m644.1 193.6c0 0 6 2.9 8.1 4.9q0.3 0.4 0.5 0.9 0.9 2.2 1.3 4.6h-12.4c0.5-3.5 1.3-7 2.5-10.4z"
        />
        <path
            className="s1_a4"
            d="m616.2 194.7c2.5-1.8 5.3-2.9 8.2-3.6l-0.4 0.5c0 0-3.7 0.7-2.7 5 0.5 2.4 1.4 5.3 2.1 7.4h-12.1q0.3-1.1 0.6-2.1c1.1-3.4 2.6-6.1 4.3-7.2z"
        />
        <path
            className="s1_a5"
            d="m624 191.6l0.4-0.5 2.5-2.8-0.2-3.2c0 0 3.2-1.3 3.3-2.7q-0.2 2-0.4 4.1c-0.5 5.5-1.2 11.6-1.7 17.5h-4.5c-0.7-2.1-1.6-5-2.1-7.4-1-4.3 2.7-5 2.7-5z"
        />
        <path
            className="s1_a5"
            d="m615.9 169.2c-0.2-0.6 0.1-1.7 0.1-1.7 0 0 1.5-4.9 2-5.8q0.6-0.9 1.2-1.6c0.8-0.5 1.9-1.4 2.9-1.3 5.2 0.3 6.5 6.5 7.7 13.3 0.5 2.5 0.5 6.1 0.2 10.3-0.1 1.4-3.3 2.7-3.3 2.7-2.3 1.3-4.4 1.8-5.7 1.7-2.5-0.1-2.2-2.2-2.3-3.6-0.1-1.3-1-2-2.7-5.3q-0.1-0.3-0.3-0.7c-0.6-1.2-0.6-2.6-0.3-3.8q0.1-0.5 0.3-0.9c0.3-1.1 0.4-2.2 0.2-3.3z"
        />
        <path
            className="s1_a3"
            d="m641.6 204h-13.7c0.5-5.9 1.2-12 1.7-17.5q0.2-2.1 0.4-4.1c0.2-4.2 0.3-7.8-0.2-10.3-1.3-6.8-2.5-13-7.7-13.3-1-0.1-2.1 0.8-2.9 1.3-0.4 0.5-0.8 1-1.2 1.6-0.5 0.9-2 5.8-2 5.8 0 0-0.3 1.1-0.1 1.7 0.2 1.1 0.1 2.2-0.2 3.3q-0.2 0.4-0.3 0.9c-0.2-2.2-0.3-4.3-0.1-6.2 0.5-4.3 1.7-6.2 2.5-6.9q-0.1-0.3 0-1.1c1.2-2.2 11.4-8.5 20.5-1.8 8.8 6.6 7.9 34.6 14.1 41.3q-0.1-0.1-0.2-0.2c-2.1-2-8.1-4.9-8.1-4.9-1.2 3.3-2 6.9-2.5 10.4z"
        />
        <path
            className="s1_a6"
            d="m176.5 409.7l-0.8-0.5 1.4 1.1q-0.3-0.3-0.6-0.6z"
        />
        <path className="s1_a7" d="m238.2 421.2h-60v-60h60z" />
        <path
            className="s1_a8"
            d="m220.3 409l-2.9-2v-0.8c0.7 0.1 1.3 0.1 1.8 0.1 2.7-0.3 1.9-2.4 5.1-9.9 0.7-1.5 0.4-3 0-4-0.2-0.7-0.3-1.6-0.2-2.4 0.3-1.5-0.1-3.3-0.5-4.9-0.4-1.1-2.3-6.9-6.3-7 0 0-2.4 4.8-10.7 6.5-1.6 3.6-1.7 8-1.3 9.5 0.1 0.1-0.1 0.2-0.2 0.1l-1-1.4q0 0 0 0l-1.4-1.8c-0.6-1-1.7-1.2-2-1.3q-0.1 0-0.2 0c-2.4 0.5-0.7 4.7 0.2 6.4 0.3 0.6 0.6 1 0.8 1.3 0.5 0.6 0.9 0.7 1.7 0.5q0.1 0 0.1 0l-0.6 8.2c0 0.3-0.1 0.7-0.4 0.9l-1.5 0.9c0 0 10.3 7.3 19.5 1.1z"
        />
        <path
            className="s1_a9"
            d="m203.4 397.9c0 0-0.1 0-0.2 0-0.7 0.2-1.2 0.1-1.6-0.4-0.3-0.4-0.6-0.8-0.9-1.4-0.9-1.7-2.6-5.9-0.1-6.4q0 0 0.1 0c0.3 0.1 1.4 0.3 2.1 1.3l1.3 1.8q0 0 0 0l1 1.4c0.1 0.1 0.3 0.1 0.2-0.1-0.4-1.5-0.2-5.9 1.3-9.5 8.4-1.7 10.8-6.5 10.8-6.5 3.9 0.1 5.8 5.9 6.2 7q0 0.1 0.1 0.1c1.8-15.4-12.3-13-12.3-13-3 0-4.5 0.4-6.6-0.5-0.7-0.2-1.5-0.7-1.9-0.3-0.6 0.4-0.4 1.6-0.1 2.6-1.1-0.7-1.7-0.5-2-0.4-1.4 0.4-2.1 3.9-2.1 3.9-0.1 1 0.3 1.9 0.8 2.8-1.3 1.5-2.9 4.8-1.4 10.8 2.5 9.2 2.3 9.6 5 10.4 0 0 0.3-3.7 0.3-3.7z"
        />
        <path
            className="s1_a9"
            d="m231.3 421.2c-0.6-3.2-2.3-6-4.9-7.9l-1.7-1.2-2.3-1.7-2.1-1.5c0 0 0 0.1 0 0.1-9.2 6.2-19.4-1.1-19.4-1.1-5.2 2-13.1 5-13.8 5.9-1.8 1.2-3.2 3.1-3.5 5.4l-0.3 2h48z"
        />
        <path
            fillRule="evenodd"
            className="s1_a9"
            d="m226.1 391.2c0 2.4-1.3 4.3-3 4.3-0.6 0-1.2-0.3-1.7-0.8-0.7-0.7-1.1-1.7-1.2-2.9h-0.9c-0.3 2.3-2.2 4-4.6 4-2.3 0-4.3-1.8-4.5-4.1l-5.9 0.5q0 0-0.1 0c-0.3 0-0.5-0.2-0.5-0.5-0.1-0.3 0.2-0.6 0.5-0.6l6-0.5c0.1-1 0.6-1.9 1.3-2.6 0.8-0.9 2-1.3 3.2-1.3 1.2-0.1 2.4 0.4 3.3 1.3 0.7 0.7 1.1 1.6 1.3 2.7h0.9c0.2-2.1 1.4-3.7 2.9-3.7 0.6 0 1.2 0.2 1.7 0.7 0.8 0.8 1.3 2.1 1.3 3.5zm-11.4 3.5c1.9 0 3.5-1.6 3.5-3.5 0-0.9-0.4-1.8-1-2.4-0.7-0.7-1.6-1-2.5-1-0.9 0-1.8 0.3-2.4 1-0.7 0.6-1 1.5-1 2.4 0 1.9 1.5 3.5 3.4 3.5zm10.2-3.5c0-1-0.3-2.1-0.9-2.6-0.2-0.2-0.5-0.5-0.9-0.5-1 0-1.9 1.5-1.9 3.2 0 1 0.4 2.1 1 2.6 0.2 0.2 0.5 0.5 0.9 0.5 1 0 1.8-1.5 1.8-3.2z"
        />
        <g style={{ opacity: 0.2 }}>
            <path
                className="s1_aa"
                d="m346.8 149.1c0-0.7 0.5-1.3 1.2-1.3h44.3c0.7 0 1.3 0.6 1.3 1.3v7.8c0 0.7-0.6 1.3-1.3 1.3h-44.3c-0.7 0-1.2-0.6-1.2-1.3z"
            />
            <path
                className="s1_aa"
                d="m221.7 160.2c-3.9 0-7.1-3.2-7.1-7.2 0-3.9 3.2-7.1 7.1-7.1 3.9 0 7.1 3.2 7.1 7.1 0 4-3.2 7.2-7.1 7.2z"
            />
            <path className="s1_aa" d="m238.9 150.5h68.6v5h-68.6z" />
            <path className="s1_aa" d="m449.2 150.5h68.7v5h-68.7z" />
        </g>
        <path
            className="s1_Z"
            d="m583 157.4c-5 0-9-3.2-9-7.1 0-3.9 4-7 9-7 5 0 9 3.1 9 7 0 3.9-4 7.1-9 7.1z"
        />
        <path
            fillRule="evenodd"
            className="s1_ab"
            d="m588.5 166.1c0 0-2-2.9-1-4v0.1c1.5-1.7 2.5-3.8 2.5-6 0-5.3-5.2-9.7-11.5-9.7-6.4 0-11.6 4.3-11.6 9.7 0 5.3 5.2 9.6 11.6 9.6 1.8 0 3.5-0.4 5-1 1.3 1.3 3 2 4.2 2.2q0.1 0 0.2 0 0.2 0 0.3 0 0.1-0.1 0.2-0.3 0.1-0.1 0.1-0.3 0.1-0.1 0-0.3z"
        />
        <path
            className="s1_Z"
            d="m578.5 163.2c-5 0-9-3.1-9-7 0-3.9 4-7.1 9-7.1 4.9 0 8.9 3.2 8.9 7.1 0 3.9-4 7-8.9 7z"
        />
        <path
            className="s1_ab"
            d="m583.4 153.3h-9.2c-0.6 0-1.2 0.5-1.2 1.1 0 0.6 0.6 1.2 1.2 1.2h9.2c0.7 0 1.2-0.6 1.2-1.2 0-0.6-0.5-1.1-1.2-1.1z"
        />
        <path
            className="s1_ab"
            d="m577.7 157.4h-3.5c-0.6 0-1.2 0.6-1.2 1.2 0 0.6 0.6 1.1 1.2 1.1h3.5c0.6 0 1.1-0.5 1.1-1.1 0-0.6-0.5-1.2-1.1-1.2z"
        />
        <path
            fillRule="evenodd"
            className="s1_ab"
            d="m714.8 271.8l9.2 1.1c1.3 0.1 2.2 1.3 2.1 2.5l-1.1 9.2c-0.1 1.3-1.3 2.2-2.5 2l-9.2-1c-1.3-0.2-2.2-1.3-2-2.6l1-9.1c0.1-1.3 1.3-2.2 2.5-2.1z"
        />
        <path
            fillRule="evenodd"
            className="s1_Z"
            d="m715.8 277.8q0.2 0.1 0.3 0.3l1.3 1.7 4.2-3.4q0.2-0.1 0.4-0.2 0.3-0.1 0.5 0 0.2 0 0.4 0.1 0.2 0.1 0.4 0.3 0.1 0.2 0.2 0.4 0 0.2 0 0.5 0 0.2-0.1 0.4-0.1 0.2-0.3 0.3l-5.1 4.1q-0.4 0.3-0.9 0.2-0.5 0-0.7-0.4l-2.1-2.5q-0.1-0.2-0.2-0.4-0.1-0.3 0-0.5 0-0.2 0.1-0.4 0.1-0.2 0.3-0.4 0.2-0.1 0.4-0.2 0.2 0 0.5 0 0.2 0 0.4 0.1z"
        />
        <path
            fillRule="evenodd"
            className="s1_ab"
            d="m156.5 379.1c0.3-0.3 0.6-0.5 1-0.5 0.4 0 0.8 0.2 1.1 0.5l6.7 6.6c0.2 0.3 0.4 0.7 0.4 1 0 0.4-0.2 0.8-0.5 1.1-0.2 0.2-0.6 0.4-1 0.4-0.3 0-0.7-0.2-1-0.4l-5.6-5.7-5.7 5.7c-0.3 0.2-0.7 0.4-1 0.4-0.4 0-0.8-0.2-1-0.4-0.3-0.3-0.5-0.7-0.5-1.1 0-0.3 0.2-0.7 0.5-1l6.6-6.6z"
        />
        <path
            fillRule="evenodd"
            className="s1_ab"
            d="m156.5 371.1c0.3-0.3 0.6-0.5 1-0.5 0.4 0 0.8 0.2 1.1 0.4l6.7 6.7c0.2 0.3 0.4 0.7 0.4 1 0 0.4-0.2 0.8-0.5 1-0.2 0.3-0.6 0.5-1 0.5-0.3 0-0.7-0.2-1-0.4l-5.6-5.7-5.7 5.7c-0.3 0.2-0.7 0.4-1 0.4-0.4 0-0.8-0.2-1-0.5-0.3-0.2-0.5-0.6-0.5-1 0-0.3 0.2-0.7 0.5-1l6.6-6.7z"
        />
    </svg>
);
